import { AdminDashboardInfoItem } from "components/design/welcomeUser";
import Async from "components/DesignSystem/AsyncComponents/Async";
import { useGetAppSubscriptionDetailsQuery } from "store/apis/serviceTeam";

export const AdminAppSubscriptions = () => {
  const { data, isLoading, isSuccess } = useGetAppSubscriptionDetailsQuery();

  return (
    <div className="t-rounded-lg t-border t-border-solid t-border-neutral-10 t-p-4 t-space-y-5">
      <div className="t-text-subtitle-lg t-text-text-100">
        App Subscriptions
      </div>
      <Async.Root {...{ isLoading, isSuccess, isEmpty: false }}>
        <Async.Empty>
          <></>
        </Async.Empty>
        <Async.Success>
          <div className="t-grid sm:t-grid-cols-2 md:t-grid-cols-3 t-gap-y-8 t-gap-x-[60px] sm:t-gap-x-4 sm:t-gap-y-5">
            <AdminDashboardInfoItem
              header="Inkle Tax Free Plan"
              info={data?.inkle_tax_free_plan}
            />
            <AdminDashboardInfoItem
              header="Inkle Books Free Plan"
              info={data?.inkle_books_free_plan}
            />
            <AdminDashboardInfoItem
              header="Inkle Virtual Mailroom"
              info={data?.inkle_virtual_mailroom}
            />
            <AdminDashboardInfoItem
              header="Inkle Tax Standard Plan"
              info={data?.inkle_tax_standard_plan}
            />
            <AdminDashboardInfoItem
              header="Inkle Books Standard Plan"
              info={data?.inkle_books_standard_plan}
            />
            <AdminDashboardInfoItem
              header="Inkle Registered Agent"
              info={data?.inkle_registered_agent}
            />
          </div>
        </Async.Success>
      </Async.Root>
    </div>
  );
};
